import { Map } from "immutable";
import React from "react";

export const CompanyFunctionsContext = React.createContext(Map());
